import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { User } from '../../driver/create-driver/create-driver.component';

@Component({
  selector: 'g10-edit-guest',
  templateUrl: './edit-guest.component.html',
  styleUrls: ['./edit-guest.component.css']
})
export class EditGuestComponent implements OnInit {

 
  matFormSize = '13px'
  guestForm: FormGroup;

  public editLocation:boolean=true;
  public guestLocation = {};
  public locationData = {};

  public guestID;
  public updateValues=[];
  formSubmit:boolean=false;

  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public route: ActivatedRoute,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public file: FileUploadService
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.guestID = params.params.guestID;
    });
  }

  ngOnInit(): void {
    this.addFormLoad();
    setTimeout(()=> this.getGuestData() ,500);
  }

  addFormLoad() {
    this.guestForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      gender: new FormControl('', [Validators.required]),
      mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      userType: new FormControl('',[Validators.required]),
      location: new FormControl('', [Validators.required]),
    });
  }

  getGuestData() {
    const obj = {
      guestID: this.guestID
    };
    this.api.transportManagerGuestList(obj).then((res: any) => {
      if (res.status == 'success') {
        const data = res.data[0];
        this.setValueGuestForm(data);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  setValueGuestForm(data) {
    console.log(data);
    this.guestForm.patchValue({
      name: data.name,
      email: data.email,
      gender: data.gender,
      mobile: data.mobile,
      userType: data.userType,
      location: data.location,
    });
    this.locationData = { 'name':data.location,'lat':data.lat,'lng':data.lng};
    this.guestLocation = { ...this.locationData};
  }

  getLocation(obj){
    console.log(obj);
    this.guestLocation = {...obj};
    this.fieldChange(this.guestLocation,'location','location'); 
  }

  /* update unique field*/
  fieldChange(e:any,type,field){
    if(type=='text' || type=='textarea'){
      this.updateField(field,e.target.value);
    }
    if(type=='date' || type=='dropdown'){
      this.updateField(field,e.value);
    }
    if(type=='location'|| type=='file' || type=='branch'){
      this.updateField(field,e);
    }
  }
  updateField(field,value){
    if(this.updateValues.length>0){
      let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
      let obj={field:field,value:value,};
      this.updateValues=[
        ...filterUpdate,
        obj,
      ]
    }
    else{
      let obj={field:field,value:value,};
      this.updateValues.push(obj);
    }
    console.log(this.updateValues);
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.guestForm.controls[controlName].hasError(errorName);
  }

  onSubmit() {
    this.formSubmit = true;
    if(this.guestForm.valid && this.updateValues && this.updateValues.length>0){
      const obj = {
        guestID: this.guestID,
      };
      this.updateValues.filter((e)=>{
        if(e.field=='location'){
          obj['location'] = this.guestLocation['name'];
          obj['lat'] = this.guestLocation['lat'];
          obj['lng'] = this.guestLocation['lng'];
        }
        else{
          obj[e.field]=e.value;
        }
      });
      console.log(obj);
      this.api.transportManagerGuestUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/guest/view-guest'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });

    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
/* 
{
  "name": "shankar",
  "email": "shankar@groupten.com",
  "gender": "Male",
  "mobileNo": "9962020798",
  "userType": "Escort",
  "location": "Sutherland Global Services, Chennai, Tamil Nadu, India",
  "lat": 12.97865,
  "lng": 80.22015
} */